export default __webpack_public_path__ + "static/media/icon-mail.19b56e3b.svg";